import { atom, useAtom } from 'jotai'

const isOpenOrdersFilterAtom = atom(false)

export const useOpenOrdersFilter = () => {
    const [isOpen, setIsOpen] = useAtom(isOpenOrdersFilterAtom)

    return { isOpen, setIsOpen }
}
